<div class="sem-progress-bar-wrap">
  <div class="sem-progress-bar">
    @for (step of steps; track step.Key; let i = $index) {
      <div class="sem-progress-bar__step" [ngClass]="stepState(i)">
        @if (i > 0) {
          <div class="sem-progress-bar__connector"></div>
        }
        <div class="sem-progress-bar__circle">
          @if (stepState(i) === 'done') {
            <span class="sem-progress-bar__check">&#10003;</span>
          } @else {
            <span class="sem-progress-bar__index">{{ i + 1 }}</span>
          }
        </div>
        <div class="sem-progress-bar__label">{{ stepLabel(step) }}</div>
      </div>
    }
  </div>
</div>
